import PopOver from './PopOver';

export default PopOver;



// WEBPACK FOOTER //
// ./app/javascript/common/components/PopOver/index.js